import React from 'react';
import Icon from '@mui/material/Icon';
import { makeStyles } from 'tss-react/mui';
import logo from '../../assets/images/logo.svg';

const useStyles = makeStyles()({
  imageIcon: {
    height: '100%',
    backgroundColor: 'white',
    padding: '2px',
    borderRadius: '50px',
  },
  iconRoot: {
    textAlign: 'center',
  },
});

export default function Logo() {
  const { classes } = useStyles();
  return (
    <Icon classes={{ root: classes.iconRoot }}>
      <img className={classes.imageIcon} src={logo} alt="logo" />
    </Icon>
  );
}
